export const aiTypesList = [
  {
    name: 'regular',
    title: 'On a facility asset',
    cardTitle: {
      requestInvestigation: 'Investigation on a facility asset',
      reportFailure: 'Report a failure on a facility asset',
    },
    description: {
      requestInvestigation:
        'OPEN AN ACTION ITEM REQUESTING THAT WAITES ANALYSTS REVIEW SENSOR DATA FOR EQUIPMENT IN YOUR FACILITY',
      reportFailure:
        'OPEN AN ACTION ITEM TO INVESTIGATE A FAILURE THAT OCCURRED ON YOUR WAITES-MONITORED EQUIPMENT THAT DOES NOT CURRENTLY HAVE AN OPEN ACTION ITEM',
    },
    icon: {
      requestInvestigation: 'AITypeRequestComponentIcon',
      reportFailure: 'AITypeFailureComponentIcon',
    },
  },
  {
    name: 'waitesWireless',
    title: 'On a network/sensor',
    cardTitle: {
      requestInvestigation: 'Investigation on Waites network/sensor',
      reportFailure: 'Report a failure on Waites network/sensor',
    },
    description: {
      requestInvestigation:
        'OPEN AN ACTION ITEM TO REPORT AN ISSUE WITH (OR A CHANGE MADE TO) WAITES HARDWARE (I.E SENSORS, REPEATERS, GATEWAYS, ETC.)',
      reportFailure:
        'Open an action item to investigate a failure of Waites Network equipment (e.g. sensors, repeaters, gateways, etc.)',
    },
    icon: {
      requestInvestigation: 'AITypeRequestHardwareIcon',
      reportFailure: 'AITypeFailureHardwareIcon',
    },
  },
];
